import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-279f2e70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/logoHome.png",
      alt: "",
      class: "logoImg"
    })
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}